package com.example.mystybag.cropImage.logic

import com.example.mystybag.common.resources.SR
import com.example.mystybag.core.expected.sharedString
import com.example.mystybag.core.logic.base.AppContext
import com.example.mystybag.core.logic.base.ChildViewModel
import com.example.mystybag.core.model.AdditionalIcon
import com.example.mystybag.core.resources.SRC
import com.example.mystybag.cropImage.expected.saveTempImgOnDisk
import com.example.mystybag.cropImage.model.ProfileImageCropperUIState
import com.example.mystybag.sharedmodels.SCImage
import kotlinx.datetime.Clock

class ProfileImageCropperViewModel(
    context: AppContext,
    val selectedImage: SCImage,
    private val callbacks: ProfileImageCropperCallbacks,
    val aspectRatio: Float? = null,
    private val outputWidth: Int? = null,
    private val outputHeight: Int? = null,
) : ChildViewModel<ProfileImageCropperUIState>(context, ProfileImageCropperUIState()) {

    private     var originalImgFileName     = ""
    override fun onCreate() {
        navControls.title = sharedString(SR.strings.crop)
        updateState {
            it.copy(
                selectedImage = selectedImage,
                aspectRatio = aspectRatio,
                outputWidth = outputWidth,
                outputHeight = outputHeight,
            )
        }

        navControls.additionalIcons  = listOf(
            AdditionalIcon(
                image   = SRC.images.revert_icon,
                action  = {
                    updateState {
                        it.copy(
                            rotateImage = true
                        )
                    }
                }
            ),
            AdditionalIcon(
                image   = SRC.images.select_icon,
                action  = {
                    updateState {
                        it.copy(
                            cropImage = true
                        )
                    }
                }
            )
        )
    }

    fun onImageRotated() {
        updateState {
            it.copy(
                rotateImage = false
            )
        }
    }

    fun onImageCropped(image: SCImage) {
        val fileName = "img_${Clock.System.now()}"
        if (saveTempImgOnDisk(fileName, image))
            callbacks.onImageCropped(fileName, originalImgFileName)
        updateState { it.copy(cropImage = false) }
    }

}


interface ProfileImageCropperCallbacks {
    fun onImageCropped(imageFileName: String, originalImgFileName: String)
}